export const CONTROL_UI_BOOTSTRAP_CONFIG_PATH = "/__openclaw/control-ui-config.json";

/** Site-root portal API (not under `controlUi.basePath`). */
export const CONTROL_UI_PORTAL_API_PREFIX = "/__openclaw/portal";

export type ControlUiPortalBootstrap = {
  /** Portal password is configured and required for non-loopback HTTP clients. */
  required: boolean;
  /** Valid portal session cookie present (or loopback / portal disabled). */
  authenticated: boolean;
  /** When true, the login form must collect username (gateway.controlUi.portalUser or env). */
  usernameRequired?: boolean;
};

export type ControlUiBootstrapConfig = {
  basePath: string;
  assistantName: string;
  assistantAvatar: string;
  assistantAgentId: string;
  serverVersion?: string;
  /** Present when gateway.controlUi.portalPassword (or env) enables the portal gate. */
  portal?: ControlUiPortalBootstrap;
};
